import { deleteTagManager } from '../api/tagManager';
export const unassignFace = async ({ personId, faceId, fileChecksum, }, logger) => {
    const urlParams = new URLSearchParams();
    faceId && urlParams.append('faceId', faceId);
    fileChecksum && urlParams.append('fileChecksum', fileChecksum);
    return deleteTagManager(`person/${personId}/face/${faceId}/file/${fileChecksum}`, {}, logger);
};
